import getStore from '../store/store';
import TodoFolderStore from '../store/schema/TodoFolderStore';

export default function getTodoFolderStore(): TodoFolderStore {
    return getStore().folders;
}
